import template from './billing_category.html'
import controller from './billing_category.controller'
import './billing_category.scss'

const billingCategoryComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default billingCategoryComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billing_category/billing_category.component.js